import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { I18nService, Language } from '../../core/i18n.service';
import { BaseComponent } from '../base/base.component';
import { IconButtonDirective } from '../button/icon/icon-button.directive';
import { ButtonSize, ButtonTheme } from '../button/base/base-button.component';
import { ISO_8601 } from 'moment';

@Component({
  selector: 'immo-language-picker',
  imports: [
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    CommonModule,
    ReactiveFormsModule,
    IconButtonDirective,
  ],
  templateUrl: './language-picker.component.html',
  styleUrl: './language-picker.component.css',
})
export class LanguagePickerComponent extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly t: TranslateService = inject(TranslateService);

  private readonly i18nService: I18nService = inject(I18nService);

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly languageControl: FormControl<string> = new FormControl<string>(this.t.getCurrentLang(), {
    nonNullable: true,
  });

  readonly languages: Language[] = this.i18nService.supportedLanguages;

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  readonly theme = input<ButtonTheme>('surface-container-lowest');

  readonly size = input<ButtonSize>('md');

  readonly outlined = input<boolean, unknown>(false, {
    transform: booleanAttribute,
  });

  // -----------------------------------------------------------------------------------------------------
  // @ LIFECYCLE HOOKS
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    // Subscribe to language changes
    this.languageControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((language) => {
        // const pathSearch: string = `${window.location.pathname}${window.location.search}`;
        // const shortLocale: string = this.languages.find((l: Language) => l.locale === language)?.shortLocale;
        // // Remove the current locale from the path.
        // const newPathSearch: string = pathSearch.replace(/\/[a-z]{2}\//, ``);
        // window.location.href = `${this.environment.websiteUrl}${shortLocale}/${newPathSearch}`;
        this.t.use(language);
      });
  }
}
